import { STATE_ARRAY, TABLE_ACTION } from "./Constants.tsx";
import { ColumnHeaderType } from "./Types.tsx";
import {
  arrayToString,
  blankValueGetter,
  numberCurrencyFormatInTable,
  numberFormat,
  numberFormatWithoutCurrency,
  numberWithoutCurrencyFormatInTable,
  selectedFilterClass,
  stateNameGetter,
  valueWithDecimalPlace,
} from "./Util.tsx";

export const STATE_VIEW_HEADERS: ColumnHeaderType[] = [
  {
    name: "State",
    field: "state",
    showFilter: true,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Premium",
    field: "premium",
    showFilter: false,
    valueGetter: numberCurrencyFormatInTable,
    clickable: false,
    classNameGetter: selectedFilterClass,
    sortable: true,
  },
  {
    name: "Sum Insured",
    field: "suminsured",
    showFilter: false,
    valueGetter: numberCurrencyFormatInTable,
    clickable: false,
    classNameGetter: selectedFilterClass,
    sortable: true,
  },
  {
    name: "Policies",
    field: "policies",
    showFilter: false,
    valueGetter: numberFormat,
    clickable: false,
    classNameGetter: selectedFilterClass,
    sortable: true,
  },
];
export const GRID_VIEW_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: true,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Premium",
    field: "premium",
    showFilter: false,
    valueGetter: numberCurrencyFormatInTable,
    clickable: false,
    classNameGetter: selectedFilterClass,
    sortable: true,
  },
  {
    name: "Sum Insured",
    field: "suminsured",
    showFilter: false,
    valueGetter: numberCurrencyFormatInTable,
    clickable: false,
    classNameGetter: selectedFilterClass,
    sortable: true,
  },
  {
    name: "Policies",
    field: "policies",
    showFilter: false,
    valueGetter: numberFormat,
    clickable: false,
    classNameGetter: selectedFilterClass,
    sortable: true,
  },
];

export const POSP_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "First Name",
    field: "first_name",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Last Name",
    field: "last_name",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Contact",
    field: "mobile_number",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
];
export const POSP_ARABLE_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Arable Area(acres)",
    field: "arable_area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
  {
    name: "Catchment Ratio",
    field: "catchment_ratio",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
];
export const POSP_TARGET_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Candidate Id",
    field: "candidate_id",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Target value",
    field: "target_value",
    showFilter: false,
    valueGetter: numberCurrencyFormatInTable,
    clickable: false, 
    sortable: true,
  },
  {
    name: "Achieved Percentage",
    field: "achieved_percentage",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
];
export const POSP_LOCATION: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
     name: "Employee Id",
    field: 'employeeuniqueid',
     showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Name",
    field: "employeename",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Role",
    field: "rolename",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },

  {
     name: "Mobile Number",
    field: 'mobile_number',
     showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: false,
  },
];

export const UNIVERSITIES_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "University Name",
    field: "college_name",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Address",
    field: "address",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
];
export const getCombinedBusinessHeaders=(item)=>{
 return [
 {
    name: item ==="POSP"?"POSP":item==="grid"?"Grid Id":item==="state"?"State":"District",
    field:  item ==="POSP"?"proposer_name" :item ==="grid"?"gridid":item ==="state"?"vstate":"vdistrict",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: item !=="grid" && item !== "POSP",
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: false,
  },
   {
    name: "Total Policy",
    field: "total_policies",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
   {
    name: "Total Premium(₹)",
    field: "total_premium",
    showFilter: false,
    valueGetter: numberWithoutCurrencyFormatInTable,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Total Sum Insured(₹)",
    field: "total_suminsured",
    showFilter: false,
    valueGetter: numberWithoutCurrencyFormatInTable,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Accepted Policies",
    field: "accepted_policies",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Accepted Premium(₹)",
    field: "accepted_premium",
    showFilter: false,
    valueGetter: numberWithoutCurrencyFormatInTable,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },{
    name: "Accepted Sum Insured(₹)",
    field: "accepted_suminsured",
    showFilter: false,
    valueGetter: numberWithoutCurrencyFormatInTable,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Claim Intimated(₹)",
    field: "total_claims",
    showFilter: false,
    valueGetter: numberWithoutCurrencyFormatInTable,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },{
    name: "Claim Calculated(₹)",
    field: "claim_calculated",
    showFilter: false,
    valueGetter: numberWithoutCurrencyFormatInTable,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Claim Paid(₹)",
    field: "total_claim_amount",
    showFilter: false,
    valueGetter: numberWithoutCurrencyFormatInTable,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Loss Ratio(%)",
    field: "loss_ratio",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Previous Season Loss Ratio(%)",
    field: "previous_season_loss_ratio",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  }
  
  
]
}

export const POLICIES_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Policy Number",
    field: "policy_numbers",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Policy Count",
    field: "policy_count",
    showFilter: false,
    valueGetter: numberFormat,
    clickable: false,
    sortable: true,
  },
  {
    name: "Crop Name",
    field: "crop_names",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Cultivator Name",
    field: "cultivator_names",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Area(acres)",
    field: "area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
];
export const CROPS_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Crop Name",
    field: "crop_name",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Premium",
    field: "premium",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Sum Insured",
    field: "sum_insured",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Area(acres)",
    field: "area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
];

export const CUSTOMERS_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Customer Name",
    field: "cultivator_name",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Crop Name",
    field: "crop_name",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
];

export const PREMIUM_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Premium",
    field: "premium",
    showFilter: false,
    valueGetter: numberCurrencyFormatInTable,
    clickable: false,
    sortable: true,
  },
  {
    name: "Premium Without GST",
    field: "premium_without_gst",
    showFilter: false,
    valueGetter: numberCurrencyFormatInTable,
    clickable: false,
    sortable: true,
  },
  {
    name: "Area(acres)",
    field: "area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
];
export const SUM_INSURED_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Sum Insured",
    field: "suminsured",
    showFilter: false,
    valueGetter: numberCurrencyFormatInTable,
    clickable: false,
    sortable: true,
  },
  {
    name: "Area(acres)",
    field: "area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
];

export const AREA_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Area(acres)",
    field: "area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
  {
    name: "Sum Insured",
    field: "suminsured",
    showFilter: false,
    valueGetter: numberCurrencyFormatInTable,
    clickable: false,
    sortable: true,
  },
  {
    name: "Premium",
    field: "premium",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
];

export const CUSTOMER_COUNT_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Area(acres)",
    field: "area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
  {
    name: "Customer",
    field: "customer_count",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
  {
    name: "Cultivator Names",
    field: "cultivator_names",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Policy Numbers",
    field: "policy_numbers",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
];
export const CLAIMS_CUSTOMER_COUNT_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Count",
    field: "count",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
];
export const CLAIMS_CLAIM_PROCESSED_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Claim Id",
    field: "claim_ids",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Payment Amount(₹)",
    field: "payout_amounts",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Area(acres)",
    field: "area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
  {
    name: "Count",
    field: "claims_count",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
];
export const CLAIMS_AMOUNT_DISBURSED_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Claim Id",
    field: "claim_ids",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Payment Amount(₹)",
    field: "payout_amounts",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Area(acres)",
    field: "area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
];
export const CLAIMS_CLAIM_RADIO_HEADERS: ColumnHeaderType[] = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Claim Id",
    field: "claim_ids",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Payment Amount(₹)",
    field: "payout_amounts",
    showFilter: false,
    valueGetter: arrayToString,
    clickable: false,
    sortable: false,
  },
  {
    name: "Loss Ratio",
    field: "loss_ratio",
    showFilter: false,
    clickable: false,
    sortable: true,
  },
];
export const CLAIMS_CLAIM_COUNT_HEADERS = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Claim Count",
    field: "claims_count",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
];
export const CLAIMS_PENDING = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Claim Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: false,
    sortable: true,
  },
];
export const INSURED_AREA_HEADER = [
  {
    name: "Grid Id",
    field: "gridid",
    showFilter: false,
    valueGetter: blankValueGetter,
    clickable: true,
    action: TABLE_ACTION.GRID_SELECTION,
    sortable: true,
  },
  {
    name: "Area(acres)",
    field: "area",
    showFilter: false,
    valueGetter: valueWithDecimalPlace,
    clickable: false,
    sortable: true,
  },
];

export const getCountryStateTableHeader = (columnName: string) => {
  return [
    {
      name: "State",
      field: "sid",
      showFilter: false,
      valueGetter: stateNameGetter,
      clickable: false,
      sortable: true,
    },
    {
      name: columnName,
      field: "total",
      showFilter: false,
      valueGetter: numberFormat,
      clickable: false,
      sortable: true,
    },
  ];
};
